/**
 * Cloned from Application Engine:
 * `src/routes/ApplicationEngine/components/ApplicationEngineTopbar/ApplicationEngineTopbar.styles.ts`
 * (VCN bulk-terminate feature is standalone; do not import ApplicationEngine.)
 */
import styled from 'styled-components'

import { colors, font, radius, toolbarControl } from './tokens'

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  width: 100%;
  min-width: 0;
  flex-wrap: wrap;
`

export const LeftSection = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  gap: 12px;
  min-width: 0;
`

/**
 * Toolbar controls, from the design's Refresh / Export / Bulk upload / Filters
 * buttons: 42px white controls with a 1px border and a 6px corner.
 *
 * Styled from the wrapper rather than as styled(Button): this app's
 * styled-components typings predate generic prop forwarding, so styled(Button)
 * drops antd's own props. `.ant-btn` also needs the extra specificity.
 */
export const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;

  .ant-btn {
    display: inline-flex;
    align-items: center;
    gap: ${toolbarControl.gap}px;
    height: ${toolbarControl.height}px;
    padding: 0 ${toolbarControl.paddingX}px;
    background: ${colors.surface.white};
    border: 1px solid ${colors.border.default};
    border-radius: ${radius.control}px;
    font-family: ${font.sans};
    font-size: ${toolbarControl.fontSize}px;
    font-weight: ${toolbarControl.fontWeight};
    color: ${colors.text.default};
    white-space: nowrap;
    box-shadow: none;
  }

  .ant-btn:hover,
  .ant-btn:focus {
    background: ${colors.surface.offWhite};
    border-color: ${colors.border.default};
    color: ${colors.text.default};
  }

  .ant-btn[disabled],
  .ant-btn[disabled]:hover {
    background: ${colors.surface.white};
    border-color: ${colors.border.default};
    color: ${colors.text.placeholder};
    cursor: not-allowed;
  }

  .ant-btn .anticon {
    font-size: ${toolbarControl.iconSize}px;
    line-height: 0;
  }

  /* Refresh and Filters carry no label. */
  .ant-btn.vcn-icon-only {
    width: ${toolbarControl.height}px;
    padding: 0;
    justify-content: center;
  }
`
